<template>
  <div class="cmp cmp-dialog-regist">
    <!-- 注册 -->
    <el-dialog
      class="dialog-regist"
      title="注册"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="780px"
    >
      <el-form :model="Form" :rules="rules" ref="ruleForm" label-width="170px">
        <el-form-item label="">
          <div class="text-right">
            已有账号？立即<el-button type="text" @click="loginClick"
              >登录</el-button
            >
          </div>
        </el-form-item>
        <el-form-item prop="phone" label="手机号码">
          <el-input
            prefix-icon="el-icon-mobile-phone"
            v-model.trim="Form.phone"
            :maxlength="11"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="imgCode" label="请输入图片中的验证码">
          <div class="row-flex">
            <div class="row-flex-main">
              <el-input
                class="verify-code-input"
                prefix-icon="el-icon-picture-outline"
                v-model.trim="Form.imgCode"
                :maxlength="10"
                placeholder="请输入图形验证码"
              ></el-input>
            </div>
            <div class="row-flex-suffix">
              <img
                class="verify-code-img"
                @click="getImgVerify"
                :src="`data:image/png;base64,${codeSrc}`"
                title="看不清？换一张"
              />
              <!-- <div
                class="verify-code-img"
                v-html="imgCode"
                @click="getImgVerify"
                title="看不清？换一张"
              ></div> -->
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="smsCode" label="请输入短信验证码">
          <div class="row-flex">
            <div class="row-flex-main">
              <el-input
                class="sms-code-input"
                prefix-icon="el-icon-message"
                v-model.trim="Form.smsCode"
                :maxlength="10"
                placeholder="请输入短信验证码"
              ></el-input>
            </div>
            <div class="row-flex-suffix">
              <el-button
                class="sms-code-btn"
                type="primary"
                plain
                @click="getSmsStep1"
                :disabled="timeTotal > 0"
                >{{
                  timeTotal > 0 ? timeTotal + '秒后重试' : '获取验证码'
                }}</el-button
              >
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="password" label="请输入密码">
          <el-input
            prefix-icon="el-icon-lock"
            v-model.trim="Form.password"
            :maxlength="32"
            placeholder="请输入密码"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item prop="password" label="请再次输入密码">
          <el-input
            prefix-icon="el-icon-lock"
            v-model.trim="Form.repassword"
            :maxlength="32"
            placeholder="请再次输入密码"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button class="btn-submit" type="primary" @click="submitForm"
            >完成</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { EventBus } from '@/assets/scripts/bus';
import api from '@/api/index.js';
import jstools from 'jstools-common/dist/jstools.web';
export default {
  data() {
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请确认密码'));
      } else if (value !== this.Form.password) {
        callback(new Error('两次输入的密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      imgCode: '',
      codeSrc: '',
      codeKey: '',
      timeTotal: 0,
      timer: null,
      Form: {
        phone: '',
        imgCode: '',
        smsCode: '',
        password: '',
        repassword: '',
      },
      rules: {
        imgCode: [
          { required: true, message: '请输入图形验证码', trigger: 'change' },
        ],
        smsCode: [
          { required: true, message: '请输入短信验证码', trigger: 'change' },
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'change',
          },
        ],
        repassword: [{ validator: validatePass2, trigger: 'change' }],
      },
    };
  },
  mounted() {
    EventBus.$on('registShow', () => {
      this.show();
    });
  },
  methods: {
    loginClick() {
      this.close();
      EventBus.$emit('loginShow');
    },
    show() {
      if (this.dialogVisible) return;
      this.dialogVisible = true;
      this.resetForm();
      this.getImgVerify();
    },
    close() {
      this.dialogVisible = false;
      this.resetForm();
    },
    getImgVerify() {
      this.imgCode = '';
      this.codeKey = '';
      this.codeSrc = '';
      return api
        .getVerifyCode({ type: 'image' })
        .then((data) => {
          this.codeKey = data.codeKey || '';
          this.codeSrc = data.codeStream || '';
        })
        .catch(() => {
          this.$message.error('获取图片验证码失败');
        });
      // this.imgCode = '';
      // return api
      //   .getImgVerify({ height: 40 })
      //   .then((data) => {
      //     this.imgCode = data.data;
      //   })
      //   .catch(() => {
      //     this.$message.error('获取图片验证码失败');
      //   });
    },
    testImgVerify: jstools.debounce(function () {
      return api
        .testImgVerify({
          code: this.Form.imgCode.toLowerCase(),
        })
        .then((res) => {
          if (res.data === 1) {
            this.$message.error('您输入的图形验证码错误');
          } else if (res.data === 0) {
            this.getSmsStep2();
          } else {
            this.$message.error('图形验证码输入错误');
          }
        });
    }),
    getSmsStep1() {
      this.$refs.ruleForm.validateField(['phone', 'imgCode'], (error) => {
        // 校验完成后的回调：error为undefined表示校验成功
        if (!error) {
          console.log(`校验成功`);
          this.getSmsStep2();
        } else {
          console.log(`校验失败：`, error);
        }
      });
    },
    getSmsStep2: jstools.debounce(function () {
      api
        .sendPhoneCode({
          phone: this.Form.phone,
          imageCode: this.Form.imgCode,
          phoneCodeType: 'REGISTER',
          headers: { codeKey: this.codeKey },
        })
        .then((res) => {
          console.log('getSmsStep2:', res);
          this.timeReduce();
        })
        .catch((err) => {
          this.smsErrorHandler(err);
        });
    }),
    // getSmsStep2() {
    //   api
    //     .getSms({
    //       phone: this.Form.phone,
    //       code_type: 'loginOrRegistered',
    //     })
    //     .then((res) => {
    //       console.log('getSmsStep2:', res);
    //     })
    //     .catch((err) => {
    //       this.smsErrorHandler(err);
    //     });
    //   this.timeReduce();
    // },
    smsErrorHandler(error) {
      let message = '';
      if (error.code === 1001) {
        message = '请您输入正确的手机号';
      } else if (error.code === 1002) {
        message = '短信发送失败';
      } else if (error.code === 1003) {
        message = '您还未注册,请先注册';
      } else if (error.code === 1004) {
        message = '短信发送失败';
      } else if (error.code === 1005) {
        message = '短信发送失败';
      } else if (error.code === -3) {
        message = '短信发送失败';
      } else if (error.code === 1006) {
        message = '您已经连续发送3次验证码，请1小时后再试';
      }
      this.$message.error(message || error.msg || error.message);
    },
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return false;
        api
          .regist({
            mobile: this.Form.phone,
            password: this.Form.password,
            code: this.Form.smsCode,
          })
          .then((res) => {
            console.log('注册成功：', res);
            if (res.code === 0) {
              this.$message.success('注册成功');
              this.loginClick();
            } else {
              this.$message.error(res.msg || '注册失败');
            }
          })
          .catch((err) => {
            console.log('注册错误：', err);
            this.$message.error(err.msg || '注册错误');
          });
      });
    },
    timeReduce() {
      let _this = this;
      clearInterval(this.timer);
      this.timeTotal = 60;
      this.timer = setInterval(() => {
        _this.timeTotal--;
        if (_this.timeTotal <= 0) {
          clearInterval(this.timer);
        }
      }, 1000);
    },
    resetForm() {
      this.Form = {
        phone: '',
        imgCode: '',
        smsCode: '',
        password: '',
        repassword: '',
      };
      this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
    },
  },
};
</script>
<style lang="less" scoped>
.cmp-dialog-regist {
  .sms-code-input,
  .verify-code-input {
    width: 100%;
  }
  .verify-code-img {
    width: 120px;
    height: 40px;
    cursor: pointer;
    border-radius: 4px;
    overflow: hidden;
    background: #dedede;
    /deep/ svg {
      width: 100%;
      height: 100%;
    }
  }
  .sms-code-btn {
    width: 120px;
  }
  .btn-submit {
    width: 100%;
  }
  /deep/ .el-dialog__body {
    padding: 0 30px 15px;
  }
  p {
    margin: 0;
    line-height: 2;
  }
}
</style>
